import { useQuery } from '@tanstack/react-query'

import { TaskData } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

export const RANDOM_TASK_QUERY_KEY = 'random-task'

export function useGetRandomTask(programId: string) {
  return useQuery({
    queryKey: [RANDOM_TASK_QUERY_KEY],
    queryFn: async () => {
      const { data } = await apiClient.get<TaskData>(`/int/v3/tasks/random/${programId}`)
      return data
    },
    gcTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(programId),
  })
}
